<template>
    <div>
        <template v-if="transaction_fee == true">
            <div class="page-top mb-1 mb-3">
                <h1> Add Transaction Fee </h1>
            </div>
            <div class="global-main">
                <form id="transactionFeeForm" @submit.prevent="addTransactionFeeData">
                    <div class="tab-content-inner">
                        <div class="form-group">
                            <label> Company </label>
                            <select v-model="form.companyId" data-live-search="true" name="companyId" class="selectpicker custom-select2 form-control" :class="{ 'is-invalid': form.errors.has('companyId') }">
                                <option value="" selected>Select Company</option>
                                <option v-for="company in companies" v-bind:value="company.id" v-bind:key="company.id">{{ company.name }}</option>
                            </select>
                            <has-error :form="form" field="companyId"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Transaction Type </label>
                            <select v-model="form.transactionType" name="transactionType" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('transactionType') }">
                                <option value="" selected>Select Transaction Type</option>
                                <option value="IBFT">IBFT</option>
                                <option value="BANK">LFT</option>
                                <option value="EASY_PAISA_WALLET">Easy Paisa Wallet</option>
                                <option value="SIMSIM">SIMSIM</option>
                                <option value="EASY_PAISA_CNIC">Easy Paisa CNIC</option>
                            </select>
                            <has-error :form="form" field="transactionType"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Fee Type </label>
                            <select v-model="form.feeType" name="feeType" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('feeType') }">
                                <option value="" selected>Select Fee Type</option>
                                <option value="FIXED">Fixed</option>
                                <option value="PERCENTAGE">Percentage</option>
                            </select>
                            <has-error :form="form" field="feeType"></has-error>
                        </div>
                        <div class="form-group">
                            <label> Fee </label>
                            <input v-model="form.fee" type="text" name="fee" class="form-control" :class="{ 'is-invalid': form.errors.has('fee') }">
                            <has-error :form="form" field="fee"></has-error>
                        </div>
                      <div class="form-group">
                        <label> Max Charge </label>
                        <input v-model="form.maxCharge" type="text" name="maxCharge" class="form-control" :class="{ 'is-invalid': form.errors.has('maxCharge') }">
                        <has-error :form="form" field="maxCharge"></has-error>
                      </div>
                        <div class="form-group">
                            <label> FED Type </label>
                            <select v-model="form.fedType" name="fedType" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('fedType') }">
                                <option value="" selected>Select FED Type</option>
                                <option value="INCLUSIVE">Inclusive</option>
                                <option value="EXCLUSIVE">Exclusive</option>
                            </select>
                            <has-error :form="form" field="fedType"></has-error>
                        </div>

                        <div class="form-group">
                            <label> Status </label>
                            <select v-model="form.status" name="status" class="form-control selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('status') }">
                                <option value="" selected>Select Status</option>
                                <option value="ACTIVE">Active</option>
                                <option value="INACTIVE">In-active</option>
                            </select>
                            <has-error :form="form" field="status"></has-error>
                        </div>
                    </div>
                    <div class="form-group">
                        <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                        <router-link to="/transactionFee" class="btn btn-primary float-right mr-2">Cancel</router-link>
                    </div>
                </form>
            </div>
        </template>
        <template v-else-if="transaction_fee === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="transaction_fee === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    companyId: "",
                    transactionType: "",
                    feeType: "PERCENTAGE",
                    fee: "",
                    maxCharge: 100,
                    fedType: "EXCLUSIVE",
                    status: "",
                }),
                companies: {},
                transaction_fee: null,
            };
        },
        methods: {
            addTransactionFeeData() {
                this.$Progress.start();
                this.form
                    .post("api/addTransactionFee")
                    .then((res) => {
                        if (res.status == 200) {
                            if (res.data.code == 200) {
                                this.resetForm();
                                this.$Progress.finish();
                                this.showToastBox("success", "Transaction Fee added successfully");
                                this.$router.push("/transactionFee");
                            } else {
                                this.showToastBox("error", res.data.message);
                            }
                        } else {
                            this.$Progress.fail();
                            this.showAlertBox("error", "Some error in your form data");
                            $(this.$el).find('.selectpicker').selectpicker('refresh');
                        }
                    }).then(res => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    });
            },
            resetForm() {
                this.form.companyId = "";
                this.form.transactionType = "";
                this.form.feeType = "";
                this.form.fee = "";
                this.form.maxCharge = "";
                this.form.fedType = "";
                this.form.status = "";
            },
            getTransactionFeeData() {
                axios
                    .get("/api/transactionFeeData")
                    .then((res) => {
                        this.companies = res.data;
                    })
                    .then(res => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                    })
                    .catch(err => {
                        $(this.$el).find('.selectpicker').selectpicker('refresh');
                        console.log(err);
                    });
            },
        },
        mounted() {
            this.$Progress.start();
            this.can("transaction_fee")
                .then((result) => {
                    this.transaction_fee = result.transaction_fee;
                })
                .then((result) => {
                    if (this.transaction_fee == true) {
                        this.getTransactionFeeData();
                        this.$Progress.finish();
                    } else {
                        this.$Progress.finish();
                    }
                });
        },
    }
</script>
